module.exports = __webpack_public_path__ + "static/media/squale.74300d7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squale.jpg
// module id = 234
// module chunks = 0